var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnClustered = function SvgIcnClustered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.117 4.861a1.75 1.75 0 1 1 .724-.343l.844 1.618a2.5 2.5 0 0 1 3.284 2.763l1.68.45a1.75 1.75 0 1 1-.244.763l-1.69-.452a2.5 2.5 0 0 1-3.576.938l-1.275 1.274a1.75 1.75 0 1 1-.55-.582l1.232-1.23a2.496 2.496 0 0 1 .434-3.545L5.117 4.86Z",
    fill: "#292525"
  })));
};
export default SvgIcnClustered;